const defaultState = {
  users: [],
  pagination: {
    rows: 7,
    page: 0,
  },
  search: "",
  userTypes: ["GREENPOINT", "ADMIN"],
  cards: {
    users: 0,
  },
  dataModal: null,
  createModal: false,
  deleteModal: false,
  editModal: false,
};

function reducer(state = defaultState, { type, payload }) {
  switch (type) {
    case "USERS_FETCH": {
      return { ...state, users: payload };
    }
    case "USERS_SET_CREATE_MODAL": {
      return { ...state, createModal: payload };
    }
    case "USERS_SET_DELETE_MODAL": {
      return { ...state, deleteModal: payload };
    }
    case "USERS_SET_EDIT_MODAL": {
      return { ...state, editModal: payload };
    }
    case "USERS_SET_DATA_MODAL": {
      return { ...state, dataModal: payload };
    }
    case "USERS_SET_PAGINATION": {
      return { ...state, pagination: { ...state.pagination, ...payload } };
    }
    case "USERS_SET_SEARCH": {
      return { ...state, ...payload };
    }
    case "USERS_SET_USERTYPES": {
      return { ...state, userTypes: payload };
    }
    case "USERS_FETCH_CARDS": {
      return { ...state, cards: payload };
    }
    default:
      return state;
  }
}

export default reducer;
